export default __webpack_public_path__ + "static/media/capital-empregado-oportunidade.45205ba3.svg";